<style scoped>
.settingCard {
  width: 100%;
}
</style>

<template>

<v-container class="wrapper" fluid>

  <v-layout row wrap justify-center>
    <v-flex xs12 sm10 md6 lg5 justify-center >

      <h1 class="text-xs-center">{{content.title}}</h1>

      <v-layout column wrap>

        <v-flex xs12 class="mb-4 settingCard" grow>
          <v-card class="py-2 px-4" grow>
            <v-card-title primary-title>
              <h3 class="text-xs-center mx-auto headline"><v-icon>notifications</v-icon> {{content.notifications}}</h3>
            </v-card-title>
            <v-layout row wrap justify-center>
              <v-flex v-if="pushnots_support" xs12 md6>
                <v-layout row nowrap justify-center>
                  <v-flex d-flex shrink align-center class="mx-2">
                    <h4 class="title text-no-wrap">{{content.pushnots}}:</h4>
                  </v-flex>
                  <v-spacer class="hidden-sm-and-up" ></v-spacer>
                  <v-flex d-flex shrink align-center>
                    <pushnots v-on:pushSupported="updatePushnotsSupport" />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 md6>
                <v-layout row nowrap justify-center>
                  <v-flex d-flex shrink align-center class="mx-2">
                    <h4 class="title text-no-wrap">{{content.emailnots}}:</h4>
                  </v-flex>
                  <v-spacer class="hidden-sm-and-up" ></v-spacer>
                  <v-flex d-flex shrink align-center>
                    <v-switch v-model="emailnots" :loading="emailnotsloading" @change="toggleEmailable" class="pt-2"></v-switch>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>

        <v-flex xs12 class="mb-4 settingCard" grow>
          <v-card class="pa-2" grow>
            <v-card-title primary-title>
              <h3 class="text-xs-center mx-auto headline"><v-icon>translate</v-icon> {{content.changelang}}</h3>
            </v-card-title>
            <v-layout column wrap>
              <v-flex xs12 justify-center class="mx-2">
                <Language/>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>

        <v-flex xs12 grow class="settingCard">
          <v-card class="pa-2" grow>
            <v-card-title primary-title>
              <v-layout row wrap justify-center align-center>
                <v-flex shrink>
                  <h3 class="text-xs-center mx-auto headline mx-2"><v-icon>brightness_2</v-icon> {{content.darkmode}}</h3>
                </v-flex>
                <v-flex shrink>
                  <v-switch v-model="darkmode" @change="changeDarkmode" class="pt-2 mx-2"></v-switch>
                </v-flex>
              </v-layout>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>

    </v-flex>
  </v-layout>


</v-container>

</template>

<script>

import Pushnots from '../tools/pushsubscribe'
import Language from '../tools/language';
export default {
    components: { Language, Pushnots },
    data() {
            return {
                locale: null,
                pushnots: false,
                emailnots: false,
                emailnotsloading: false,
                darkmode: null,
                pushnots_support: true,
            };
        },
        created() {
            this.locale = Lang.get();
            this.setLang();
            this.getEmailable();
            let darkmode = localStorage.getItem('dark');
            this.darkmode = darkmode && darkmode == '1' ? true : false;
        },
        methods: {
          getEmailable(){
            axios.get(
              '/api/subscription/emailable'
            ).then(res => {
              if (res.data.success == 1) {
                this.emailnots = true;
              }
            })
          },
          toggleEmailable(){
            this.emailnotsloading = true;
            axios.get(
              '/api/subscription/emailable/toggle?val=' + (this.emailnots ? 1 : 0)
            ).then(res => {
              this.emailnotsloading = false;
            }).catch(err => {
              this.emailnots = !this.emailnots;
              this.emailnotsloading = false;
            })
          },
          updatePushnotsSupport(support){
            this.pushnots_support = support;
          },
          changeDarkmode(){
            let darkmode = this.darkmode ? '1' : '0';
            localStorage.setItem('dark', darkmode);
            window.location.reload();
          },
          setLang() {
              if (this.locale == "en") {
                  this.content = {
                    title: 'Settings',
                    changelang: 'Change Language',
                    notifications: 'Notifications',
                    pushnots: 'Push Notifications',
                    emailnots: 'Emails',
                    darkmode: 'Dark Mode',
                  };
              } else if (this.locale == "he") {
                  this.content = {
                    title: 'הגדרות',
                    changelang: 'שינוי שפה',
                    notifications: 'התראות',
                    pushnots: 'התראות דחיפה',
                    emailnots: 'הודעות אימייל',
                    darkmode: 'מצב חשוך',
                  };
              }
          }
      }
};

</script>
